import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Table from 'react-bootstrap/lib/Table';
import Policy from 'cms/faqs/Article/Policy';

const RetrieveType = ({retrieveType, data, translations}) => {
  const {port, agency, phone, address, zipCode} = translations;

  return (
    <Fragment>
      {
        retrieveType === 'ekdotiria' ? <Table responsive>
          <thead>
            <tr>
              <th>{port}</th>
              <th>{agency}</th>
              <th>{phone}</th>
              <th>{address}</th>
              <th>{zipCode}</th>
            </tr>
          </thead>
          <tbody>
            {
              data.map(({location, name, phone, address, zip}, index) => (
                <tr key={index}>
                  <td>{location}</td>
                  <td>{name}</td>
                  <td>{phone}</td>
                  <td>{address}</td>
                  <td>{zip}</td>
                </tr>
              ))
            }
          </tbody>
        </Table> :
          <Policy
            companyName={data.companyName}
            cancellationPolicies={data.cancel.policies}
            openPolicies={data.open.policies}
            nonRefundableClasses={data.cancel.nonRefundableClasses}
            translations={translations}
          />
      }
    </Fragment>
  );
};

RetrieveType.propTypes = {
  retrieveType: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  translations: PropTypes.shape({
    port: PropTypes.string.isRequired,
    agency: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired
  }).isRequired
};

export default observer(RetrieveType);
